export const LOAD_DOCUMENT_LIST = 'consultation/LOAD_DOCUMENT_LIST';
export const LOAD_DOCUMENT_LIST_SUCCESS =
  'consultation/LOAD_DOCUMENT_LIST_SUCCESS';
export const LOAD_DOCUMENT_LIST_ERROR = 'consultation/LOAD_DOCUMENT_LIST_ERROR';
export const RESET_DOCUMENT_LIST = 'consultation/RESET_DOCUMENT_LIST';
